import React from 'react';
import { SparklesIcon, HeartIcon, ZapIcon, ActivityIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TransformationSection() {
  const transformations = [{
    image: 'https://cdn.magicpatterns.com/uploads/j1bAnDNAMFiUHYX4me3fWR/Rektusdiastase_Therapie__Was_Du_im_Alltag_tun_kannst.jpg',
    name: 'Romina',
    result: '−3 kg',
    weeks: '4 semanas',
    rotate: -2
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/9nVCywdEji5D2cZA4Sesut/Sarah-C-side-1024x1024.webp',
    name: 'Carolina',
    result: 'Abdomen plano',
    weeks: '4 semanas',
    rotate: 1.5
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/nCr6AyVMdri6WZpEH9gvjH/descarga_(4).jpg',
    name: 'Sofía',
    result: 'Cuerpo tonificado',
    weeks: '10 semanas',
    rotate: -1
  }];
  const outcomes = [{
    icon: SparklesIcon,
    text: 'Menos hinchazón'
  }, {
    icon: ActivityIcon,
    text: 'Más firmeza en piernas y glúteos'
  }, {
    icon: HeartIcon,
    text: 'Abdomen más activado'
  }, {
    icon: ZapIcon,
    text: 'Más fuerza y resistencia'
  }, {
    icon: ZapIcon,
    text: 'Más energía durante el día'
  }, {
    icon: ActivityIcon,
    text: 'Mejor postura'
  }, {
    icon: SparklesIcon,
    text: 'Menos pesadez'
  }, {
    icon: HeartIcon,
    text: 'Verte mejor con tu ropa'
  }, {
    icon: SparklesIcon,
    text: 'Sentirte más cómoda con tu cuerpo'
  }];
  return <section className="py-12 md:py-16 bg-brand-pink-50" data-id="element-229">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-230">
        <div className="text-center mb-10" data-id="element-231">
          <div className="inline-block bg-brand-pink-600 text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-3" data-id="element-232">
            Resultados reales
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-3" data-id="element-233">
            DE ESTO 👉 A ESTO
          </h2>
          <p className="text-base md:text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-234">
            Algunas de las transformaciones de mujeres que hicieron el programa.
          </p>
        </div>

        {/* Before/after polaroid gallery */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-16" data-id="element-235">
          {transformations.map((t, i) => <div key={i} className="bg-white rounded-2xl p-3 shadow-xl border border-gray-100" style={{
          transform: `rotate(${t.rotate}deg)`
        }} data-id="element-236">
              <div className="relative rounded-xl overflow-hidden bg-gray-100" data-id="element-237">
                <img src={t.image} alt={`Transformación de ${t.name}`} className="w-full h-auto object-cover aspect-square" data-id="element-238" />
                {/* Antes/Después overlay labels */}
                <div className="absolute top-3 left-3 bg-gray-900/80 backdrop-blur-sm text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md" data-id="element-239">
                  Antes
                </div>
                <div className="absolute top-3 right-3 bg-brand-pink-600 text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md" data-id="element-240">
                  Después
                </div>
              </div>
              <div className="px-2 pt-4 pb-2 text-center" data-id="element-241">
                <p className="text-2xl font-extrabold text-brand-pink-600 leading-none mb-1" data-id="element-242">
                  {t.result}
                </p>
                <p className="text-sm text-gray-700 font-medium" data-id="element-243">
                  {t.name} · {t.weeks}
                </p>
              </div>
            </div>)}
        </div>

        <h3 className="font-display text-2xl md:text-3xl lg:text-4xl text-center mb-3 text-gray-900" data-id="element-244">
          LO QUE VAS A LOGRAR 👇
        </h3>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-8" data-id="element-245">
          {outcomes.map((outcome, i) => {
          const Icon = outcome.icon;
          return <div key={i} className="bg-white rounded-2xl p-5 shadow-lg hover:shadow-xl transition-shadow" data-id="element-246">
                <Icon className="w-7 h-7 text-brand-pink-600 mb-2" data-id="element-247" />
                <p className="text-base md:text-lg font-semibold text-gray-900" data-id="element-248">
                  {outcome.text}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-12 text-center" data-id="element-249">
          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-250">
            Y lo más importante:
          </p>
          <p className="text-2xl md:text-3xl font-display text-brand-pink-600 mb-8" data-id="element-251">
            👉 dejar de empezar desde cero todos los lunes.
          </p>
          <CTAButton size="large" data-id="element-252">QUIERO EMPEZAR AHORA</CTAButton>
        </div>
      </div>
    </section>;
}